export default () => ({
  apiUrlManageLicenses: null,
  headPath: null,
  basePath: null,
  managedLicenses: [],
  headReport: null,
  baseReport: null,
  currentLicenseInModal: null,
  isDeleting: false,
  isLoadingManagedLicenses: false,
  isLoadingLicenseReport: false,
  isSaving: false,
  loadManagedLicensesError: false,
  loadLicenseReportError: false,
  canManageLicenses: false,
});
